import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[panelBody]',
})
export class PanelBody {
  constructor(public templateRef: TemplateRef<any>) {}
}
